import { render, staticRenderFns } from "./PromoCompareTemplateA7.vue?vue&type=template&id=43d11168"
import script from "./PromoCompareTemplateA7.vue?vue&type=script&lang=js"
export * from "./PromoCompareTemplateA7.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports